import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useErrorService, PrintableArea } from '@abroad/components'
import { AwarenessAssessmentResult } from '../components'
import API from '../utils/API'

export const ClientSurveyResult = () => {
  const { surveyId, clientId } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [survey, setSurvey] = useState(null)
  const history = useHistory()
  const Error = useErrorService()

  useEffect(() => {
    const getSurveys = async () => {
      try {
        const { data } = await API.CoachAPI.coachClient.getUserSurveyResult(
          surveyId,
          clientId,
        )
        if (data) {
          setSurvey(data)
        }
        setIsLoading(false)
      } catch (e) {
        if (
          e?.code === 'ValidationError' ||
          e?.code === 'resource_not_found' ||
          e?.code === 'not_found'
        ) {
          history.replace('/404')
        } else {
          setIsLoading(false)
          Error.showError(e)
        }
      }
    }
    if (surveyId) {
      getSurveys()
    } else {
      history.replace('/admin/home')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>Assessment Results | Abroad</title>
        <meta name='title' content='Assessment Results | Abroad' />
        <meta property='og:title' content='Assessment Results | Abroad' />
        <meta property='twitter:title' content='Assessment Results | Abroad' />
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/survey/view/${surveyId}`}
        />
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/survey/view/${surveyId}`}
        />
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/survey/view/${surveyId}`}
        />
      </Helmet>
      <AwarenessAssessmentResult
        survey={survey}
        isLoading={isLoading}
        clientId={clientId}
        isClientView
        API={API.ClientAPI}
      />
      <PrintableArea printSelector='main' />
    </>
  )
}
